export const getWheelsIconSvg = (
  width = 24,
  height = 18
) => `<svg width=${width} height=${height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.5 18C13.8807 18 15 16.8807 15 15.5C15 14.1193 13.8807 13 12.5 13C11.1193 13 10 14.1193 10 15.5C10 16.8807 11.1193 18 12.5 18Z" fill="#111111"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 2V4H6V15H6.01894C6.00639 15.165 6 15.3318 6 15.5C6 19.0899 8.91015 22 12.5 22C16.0899 22 19 19.0899 19 15.5C19 11.9101 16.0899 9 12.5 9C12.3318 9 12.165 9.00639 12 9.01894V4H22V2H2ZM10 4H8V10.8096C8.57548 10.2573 9.25239 9.80993 10 9.49816V4ZM12.5 20C14.9853 20 17 17.9853 17 15.5C17 13.0147 14.9853 11 12.5 11C10.0147 11 8 13.0147 8 15.5C8 17.9853 10.0147 20 12.5 20Z" fill="#111111"/>
</svg>
`;
